import { Header } from '@/scopes/common/components/Header'
import { mqMin, tok, tokPx } from '@sunwebgroup/ui-components'
import { Banner, Breadcrumbs, Typography } from '@sunwebgroup/ui-components/uds'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  background-color: ${tok('semantics_backgrounds_tinted_background_color')};
  min-height: 100vh;
  padding: 0;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding: 0 ${tokPx('primitives_space_32')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: 0 ${tokPx('primitives_space_48')};
  }
`

const Title = styled(Typography)`
  ${Typography.modVariant('display-g-regular')};
  margin-right: auto;
  padding-left: ${tokPx('primitives_space_16')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    ${Typography.modVariant('display-f-regular')};
    padding-left: 0;
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    ${Typography.modVariant('display-e-regular')};
  }
`

const Content = styled.div`
  align-items: start;
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  padding-top: ${tokPx('primitives_space_16')};
  max-width: ${tokPx('primitives_area_size_1440')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding-top: ${tokPx('primitives_space_24')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding-top: ${tokPx('primitives_space_32')};
  }
`

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: ${tokPx('primitives_space_16')} 0;
  position: relative;
  @media ${mqMin('primitives_breakpoint_m_min')} {
    margin: ${tokPx('primitives_space_24')} 0;
  }
  @media ${mqMin('primitives_breakpoint_l_min')} {
    margin-bottom: ${tokPx('primitives_space_32')};
  }
`

const StyledBanner = styled(Banner)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  right: ${tokPx('primitives_space_16')};
  margin-left: ${tokPx('primitives_space_16')};
  @media ${mqMin('primitives_breakpoint_m_min')} {
    right: ${tokPx('primitives_space_0')};
  }
`

export function UserProfileLayout({ children, banner }: { children: React.ReactNode, banner?: { type: 'danger' | 'success', text: string } }) {
  const intl = useIntl()

  return (
    <>
      <Header />
      <Wrapper>
        <Content>
          <Breadcrumbs
            items={[
              { id: 'home', label: intl.formatMessage({ id: 'breadcrumb_home' }), href: '/' },
              { id: 'account', label: intl.formatMessage({ id: 'breadcrumb_account' }), href: '/mijn-sunweb' },
              { id: 'user-profile', label: intl.formatMessage({ id: 'breadcrumb_user_profile' }) },
            ]}
          />
          <TitleContainer>
            <Title as="h1">{intl.formatMessage({ id: 'user_profile_title' })}</Title>
            {banner && (
              <StyledBanner
                color={banner.type}
                text={banner.text}
                size="M"
                hasIcon
                display="overlay"
              />
            )}
          </TitleContainer>
          {children}
        </Content>
      </Wrapper>
    </>
  )
}
